import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Icon    from 'app/components/common/icon';
import {
  UserEmailTypes,
}              from 'app/constants';
import prompts from 'app/prompts';
import AuthSlx from 'app/selectors/auth';

class PersonalEmailBanner extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  // We want to show this if BOTH of these are true:
  //   1. We don't yet know that the user's email is their personal email
  //   2. The user has a balance > 0. (wallet balance only; not worried about gift balance)
  get show() {
    const {currentUser} = this.props;
    if (!currentUser) return false;
    if (currentUser.emailType === UserEmailTypes.PERSONAL) return false;
    const hasWalletBalance = currentUser.balance?.amount > 0;
    if (hasWalletBalance) return true;
    return false;
  }

  onClick() {
    prompts.requirePersonalEmail();
  }

  render() {
    if (!this.show) return null;

    return (
      <div onClick={this.onClick} className="app-rpe-banner">
        <Icon.Envelope className="app-rpe-banner-icon" />
        Please verify your personal email to ensure access to your Giving Wallet
        <Icon.Caret direction="right" className="app-rpe-banner-arrow" />
      </div>
    );
  }

}

const stateToProps = (state) => ({
  currentUser: AuthSlx.currentUser(state),
});

const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PersonalEmailBanner);
